module.exports = __webpack_public_path__ + "static/media/Quicksand-Light.bbbd371d.woff";